import { render, staticRenderFns } from "./TheExportNew.vue?vue&type=template&id=3ae112b8&scoped=true&"
import script from "./TheExportNew.vue?vue&type=script&lang=js&"
export * from "./TheExportNew.vue?vue&type=script&lang=js&"
import style0 from "./TheExportNew.vue?vue&type=style&index=0&id=3ae112b8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae112b8",
  null
  
)

export default component.exports